import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ModalWrapper from '../../../../Components/ModalWrapper/ModalWrapper'
import AssignPosTerminalAccount from './AssignPosTerminalAccount'

const PosTerminals = () => {
  const terminals = [
    { name: 'NOMBA', id: 'nomba' },
    { name: 'MONIEPOINT', id: 'moniepoint' },
    { name: 'ZEDVANCE', id: 'zedvance' },
  ]

  return (
    <div className='table-responsive' style={{ overflow: 'visible' }}>
      <div className='d-flex justify-content-end mb-3'></div>
      <table className='table'>
        <thead>
          <tr>
            <td>#</td>
            <td>Terminal Name</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {terminals.map((terminal, index) => (
            <tr key={terminal.id}>
              <td>{index + 1}</td>
              <td>{terminal.name}</td>
              <td>
                {' '}
                <div
                  className='dropdown option-dropdown position-relative'
                  style={{ width: '10px' }}
                >
                  <button
                    type='button'
                    className='btn border-0 dropdown-toggle'
                    data-bs-toggle='dropdown'
                    data-bs-display='static'
                    aria-expanded='false'
                  >
                    <svg
                      width='18'
                      height='18'
                      viewBox='0 0 18 18'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                        fill='#707070'
                      />
                      <path
                        d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                        fill='#707070'
                      />
                      <path
                        d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                        fill='#707070'
                      />
                    </svg>
                  </button>

                  <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow mt-1'>
                    <li>
                      <Link className='dropdown-item' to={`/pos-transactions/${terminal.id}`}>
                        View all POS transactions
                      </Link>
                    </li>
                    <li>
                      <Link className='dropdown-item' to={`/pos-accounts/${terminal.id}`}>
                        View POS terminals
                      </Link>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PosTerminals
